import { Description, Dialog, DialogHeader, Heading } from '@gitbook/spine-react';

import {
    CreateSiteExternalLinkForm,
    type CreateSiteExternalLinkFormProps,
} from './CreateSiteExternalLinkForm';

export function CreateSiteExternalLinkDialog(props: CreateSiteExternalLinkFormProps) {
    return (
        <Dialog>
            <DialogHeader>
                <Heading>Add external link</Heading>
                <Description>
                    Link to a resource outside this site directly from its navigation.
                </Description>
            </DialogHeader>
            <CreateSiteExternalLinkForm {...props} />
        </Dialog>
    );
}
